module.exports = __webpack_public_path__ + "media/images/premium/premium_ui_tw_01-450-26bfc1a59380c6e04db1155cc63b88e0.png";